import type { FC, ReactNode } from "react"
import classNames from "classnames"
import "./index.scss"

type EmptyProps = {
  className?: string
  content?: ReactNode
}

const Empty: FC<EmptyProps> = ({ className, content }) => {
  const dpr = Math.floor(window.devicePixelRatio) <= 1 ? 1 : 2

  return (
    <div className={classNames("empty-wrapper", className && className)}>
      <img
        className="empty-img"
        src={require(`@/assets/empty/error@${dpr}x.png`)}
        alt="暂无数据"
        width="79"
        height="74"
      />
      <p className="empty-context">{content}</p>
    </div>
  )
}

export default Empty
